import { default as Dropzone } from "./dropzone/source.js";

Dropzone.autoDiscover = false;

export default Dropzone;
